module.exports = __webpack_public_path__ + "fromGroomToFather-we-g.0e3f18af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-we-g.jpg
// module id = V+p3
// module chunks = 0